import type { FeatureRoute } from '@/shared/registry'

import { dataDownloadPath } from './paths'

/** The page a data download link opens, signed in or not (bug 109229). */
export const dataDownloadRoutes: readonly FeatureRoute[] = [
  {
    path: dataDownloadPath,
    titleId: 'siteManagement.dataDownload.title',
    page: () => import('./DataDownloadPage').then((module) => module.DataDownloadPage),
    public: true,
  },
]
